import {mapState} from "vuex";

export const bankMixin = {
    computed: {
        ...mapState('ais', ['banks'])
    },
    methods: {
        swiftToBankName(swift) {
            const bank = this.banks.find(b => b.swift === swift)
            if (bank) {
                return `${bank.name} ${bank.country}`
            }
            return swift
        }
    }
};
